/* eslint-disable react/prop-types */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import { List } from 'react-virtualized';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';

const VirtualRouteList = ({
  routes,
  routeKeys,
  rowHeight,
  onSelectRoute,
  onDeleteRoute,
  width,
  height
}) => {

  const rowRenderer = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    style // Style object to be applied to row (to position it)
  }) => {
    const route = routes[routeKeys[index]];
    if (route) {
      return (
        <div
          key={key}
          style={style}
          className="flex justify-between cursor-pointer hover:bg-gray-200"
          onClick={() => {
            onSelectRoute(route);
          }}>
          <div className="p-4">
            {route.enabled ? (
              <div className="inline-block px-2 py-1 mr-2 text-xs text-white bg-green-500 rounded">
                Enabled
              </div>
            ) : (
              <div className="inline-block px-2 py-1 mr-2 text-xs text-white bg-red-500 rounded">
                Disabled
              </div>
            )}
            <p className="inline">{route.eircode}</p>
          </div>

          <div>
            <IconButton
              onClick={e => {
                e.stopPropagation();
                onDeleteRoute(route.eircode, route.id);
              }}>
              <Delete />
            </IconButton>
          </div>
        </div>
      );
    }
    return null;
  };

  if (routes) {
    return (
      <div className="p-2">
        <List
          className="outline-none"
          width={width}
          height={height}
          rowCount={routeKeys.length}
          rowHeight={rowHeight}
          rowRenderer={rowRenderer}
        />
      </div>
    );
  } else {
    return null;
  }
};

export default VirtualRouteList;
